import { Link } from "react-router-dom";

function Home() {
  return (
    <main>
      <section className="hero">
        <div className="hero-copy">
          <span className="eyebrow">
            Research · Development · Market Exploitation
          </span>

          <h1>Turning strong ideas into market-ready solutions.</h1>

          <p>
            R&Do Ltd. helps organisations, researchers, innovators and project
            partnerships move from concept, prototype or research outcome to a
            product, service or digital solution that can reach its audience,
            respond to real market needs and create measurable value.
          </p>

          <div className="hero-actions">
            <Link to="/projects" className="btn primary">
              Explore Projects
            </Link>

            <Link to="/contact" className="btn secondary">
              Start a Conversation
            </Link>
          </div>
        </div>

        <div className="hero-visual">
          <img src="/images/hero.jpg" alt="R&Do digital innovation" />
        </div>
      </section>

      <section className="section intro-grid">
        <div className="section-heading">
          <span className="eyebrow">What we do</span>
          <h2>We connect ideas, technology, people and markets.</h2>
        </div>

        <div className="cards three">
          <article className="card">
            <h3>Exploitation & Commercialisation</h3>
            <p>
              We help transform research results, prototypes and early-stage
              ideas into practical, market-facing products and services with a
              clear route to adoption, visibility and revenue.
            </p>
          </article>

          <article className="card">
            <h3>Communication & Dissemination</h3>
            <p>
              We design communication strategies, campaigns, digital content and
              dissemination activities that make innovation understandable,
              attractive and accessible to the right audiences.
            </p>
          </article>

          <article className="card">
            <h3>Digital Solutions & Data Management</h3>
            <p>
              We develop web platforms, digital tools, learning environments,
              data-driven services and AI-ready workflows that support real
              users, real decisions and long-term project impact.
            </p>
          </article>
        </div>
      </section>

      <section className="section process-section">
        <div className="section-heading">
          <span className="eyebrow">From idea to market</span>
          <h2>A practical path from potential to value.</h2>
        </div>

        <div className="process-grid">
          <article className="process-card">
            <span>01</span>
            <h3>Understand the idea</h3>
            <p>
              We examine the concept, prototype, research outcome or digital
              product and identify what problem it solves, who it serves and
              where its strongest potential lies.
            </p>
          </article>

          <article className="process-card">
            <span>02</span>
            <h3>Listen to the market</h3>
            <p>
              Through active market listening, trend monitoring, stakeholder
              insight and user-oriented thinking, we shape the solution around
              actual demand instead of assumptions.
            </p>
          </article>

          <article className="process-card">
            <span>03</span>
            <h3>Design the route forward</h3>
            <p>
              We support product refinement, positioning, communication,
              networking, data management and exploitation planning so the idea
              becomes ready for real-world use.
            </p>
          </article>

          <article className="process-card">
            <span>04</span>
            <h3>Bring it to the market</h3>
            <p>
              We help make the solution visible, credible and accessible through
              partnerships, marketing, dissemination channels, commercialisation
              actions and strategic networking.
            </p>
          </article>
        </div>
      </section>

      <section className="section split">
        <div>
          <span className="eyebrow">Vision</span>
          <h2>Innovation should not stay trapped inside a deliverable.</h2>
        </div>

        <p>
          Our vision is to help research, technology and creative ideas survive
          beyond the project timeline. We work where development, communication,
          exploitation, IPR management, marketing and networking meet — because
          a good idea only becomes valuable when people can understand it, use it
          and trust it.
        </p>
      </section>

      <section className="section cards two focus-cards image-cards">
        <article className="card large image-card">
          <div className="image-card-photo">
            <img
              src="/images/active-market-listening.jpg"
              alt="Active market listening and market research"
            />
          </div>

          <div className="image-card-content">
            <h3>Active Market Listening</h3>

            <p>
              Markets move quickly. Technologies change, user expectations evolve
              and opportunities appear before most organisations are ready for
              them. R&Do keeps close contact with trends, stakeholders, partners
              and users so that each solution is shaped with the market in mind.
            </p>
          </div>
        </article>

        <article className="card large image-card">
          <div className="image-card-photo">
            <img
              src="/images/strategic-exploitation.jpg"
              alt="Strategic exploitation and commercialisation planning"
            />
          </div>

          <div className="image-card-content">
            <h3>Strategic Exploitation</h3>

            <p>
              We support the transition from “this is a promising result” to “this
              can become a service, product or business opportunity.” That means
              thinking early about value, ownership, communication, adoption,
              commercialisation and long-term sustainability.
            </p>
          </div>
        </article>
      </section>

      <section className="section cta">
        <h2>Have an idea, prototype or project result with market potential?</h2>

        <p>
          R&Do can help shape it, position it, communicate it and move it toward
          meaningful use — with the right digital tools, partnerships and
          exploitation strategy behind it.
        </p>

        <Link to="/contact" className="btn primary">
          Contact R&Do
        </Link>
      </section>
    </main>
  );
}

export default Home;